import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import useResponsive from '../../../hooks/useResponsive';

export default function ChartCard({
  title,
  subtitle,
  loading = false,
  error = null,
  height = 320,
  footer = null,
  children,
}) {
  const { isMobile } = useResponsive();

  const resolvedHeight = typeof height === 'object'
    ? (isMobile ? height.xs : height.md)
    : (isMobile ? Math.round(height * 0.75) : height);

  return (
    <Paper
      sx={{
        p: { xs: 1.5, md: 2.5 },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {subtitle && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.25 }}>
          {subtitle}
        </Typography>
      )}
      <Typography
        variant="h6"
        sx={{ mb: 2, fontWeight: 600, color: 'text.primary', fontSize: '0.95rem' }}
      >
        {title}
      </Typography>

      {error ? (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error.message || 'Error al cargar los datos'}
        </Alert>
      ) : loading ? (
        <Skeleton variant="rectangular" width="100%" height={resolvedHeight} sx={{ borderRadius: 1.5 }} />
      ) : (
        <>
          <Box sx={{ height: resolvedHeight, flexShrink: 0 }}>{children}</Box>
          {footer}
        </>
      )}
    </Paper>
  );
}
